<template>
	<c-dialog ref="dialog"height="330" width="450" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
            <c-form-item label="审批结果" required>
                <c-radio-group name="withdraw_status" :options="withdrawStatusDic" v-model="withdrawStatus"></c-radio-group>
            </c-form-item>
            <c-form-item label="打款凭证" v-if="withdrawStatus == 3" required>
                <c-upload-file name="pay_voucher_img_url" type="image"></c-upload-file>
            </c-form-item>
			<c-form-item label="驳回原因" required v-show="withdrawStatus == 6">
                <c-input type="textarea" name="reject_reason" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'withdrawAudit',

	components: {
	},
	
	data() {
		return {
            //审批结果
            withdrawStatusDic: [
                {name: '审批通过',value: 3,color: 'blue'},
                {name: '审批驳回',value: 6,color: 'red'},
            ],
            withdrawStatus:3,         //审批状态
            userType:1,               //提现用户类型 1=商户主账号  3=小黑会员
            withdrawApplyIds:[]       //提现申请ID集合
		}
	},

	computed: {
		...mapState(['systemConfig', 'userTypeDic', 'saasInfo', 'pricingTypeDic']),
	},

	methods: {
		/*********打开编辑框，初始化**********/
        open(user_type,ids) {
            this.userType = user_type,
            this.$refs.form.clear();
            this.$refs.form.set({
                withdraw_status:this.withdrawStatus
            });
            this.withdrawApplyIds = ids||[];
			//填充form表单
			this.$refs.dialog.open({
				title: '提现申请审批'
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.userType==1?'/withdraw/saas/audit':'withdraw/platform_user/audit',
				rule: {
                    withdraw_status: '请选择审批结果',
                    pay_voucher_img_url: [{
                        type: 'empty',
                        message: '请上传打款凭证',
                        skip: () => {
                            return this.withdrawStatus == 6;
                        }
                    }],
                    reject_reason: [{
                        type: 'empty',
                        message: '请输入审核驳回原因',
                        skip: () => {
                            return this.withdrawStatus == 3;
                        }
                    }]
				},
				dataFormatter: data => {
                    data.withdraw_apply_ids = this.withdrawApplyIds;
                    return data;
				},
				success: (data, res) => {
					next();
                    this.$message({
                        message: '提现审批成功',  // 提示内容,
                        type: 'success'
                    });
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>